import { Box } from '@mui/material';
import NewsAndChangelog from '../../Changelogs/NewsAndChangelog';
import DashboardWidgetCard from '../DashboardWidgetCard';

// Software-update / news widget, visible to every user. Wraps the existing
// NewsAndChangelog feed in the standard dashboard card with a scrollable body.
export default function SoftwareUpdatesWidget({ widget, editMode, onHide, dragHandleProps }) {
  return (
    <DashboardWidgetCard
      title={widget.title}
      icon={widget.icon}
      accent={widget.accent}
      editMode={editMode}
      onHide={onHide}
      dragHandleProps={dragHandleProps}
    >
      <Box sx={{ maxHeight: { xs: 360, sm: 420 }, overflowY: 'auto', mx: -0.5, px: 0.5 }}>
        <NewsAndChangelog mode='changelog' />
      </Box>
    </DashboardWidgetCard>
  );
}
